import { type BudgetPeriodConstructor } from '@webapp/platform/finance'
import { type BudgetPeriodApiModel } from '../api-models/BudgetPeriodApiModel'

export const mapBudgetPeriodApiModel = (
  apiModel: BudgetPeriodApiModel
): BudgetPeriodConstructor => ({
  startDate: apiModel.start_datetime,
  endDate: apiModel.end_datetime,
  expired: apiModel.expired,
})
